module.exports = "/assets/data/96397f877c8fbb933badf1e220fc5163-NG15.data.json";